import { useSelector } from "react-redux";
import { showFeature } from "../../lib/featureUtils";
import { key, trans } from "../../lib/utils";
import store from "../../stores/store";
import { getFeatureInfo } from "../map/mapUtils";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import Geocode from "react-geocode";
import { useState } from "react";
import "./style.css";

function GooglePanel() {
  const googleGeocoding = useSelector(
    (state) => store.getState().map.google.geocoding
  );

  const layers = useSelector((state) => store.getState().layers);
  const sources = useSelector((state) => store.getState().sources);

  const [reverseGeocodingResults, setReverseGeocodingResults] = useState([]);

  Geocode.setApiKey(window["appConfig"]()["googleApiKey"]);
  Geocode.setLanguage("en");

  function onGoogleReverseGeocoding(e) {
    Geocode.fromLatLng(e.coordinate[1], e.coordinate[0]).then(
      (response) => {
        const address = response.results[0].formatted_address;

        let point = {
          projection: window["map"].getView().getProjection().getCode(),
          event: { coordinate: e.coordinate, pixel: [] },
          label: address,
        };

        store.dispatch({
          type: "map/google/geocoding/add",
          payload: { ...point },
        });
      },
      (error) => {
        console.error(error);
      }
    );

    window["map"].un("singleclick", onGoogleReverseGeocoding);
  }

  const showPoint = (_coords, _projection) => {
    let feature = {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: _coords,
      },
      projection: _projection,
      id: key(),
    };

    console.log(feature);

    showFeature(feature);

    window["recaclulatePerfectScrollbarHeight"]();
  };

  const reverseGeocoding = (address) => {
    if (address) {
      Geocode.fromAddress(address).then(
        (response) => {
          const { lat, lng } = response.results[0].geometry.location;
          console.log(lat, lng);

          console.log(response.results);

          setReverseGeocodingResults(response.results);
        },
        (error) => {
          setReverseGeocodingResults([]);
        }
      );

      window["recaclulatePerfectScrollbarHeight"]();
    }

    setReverseGeocodingResults([]);
  };

  return (
    <div className="me-3">
      <PerfectScrollbar style={{ height: "45px", overflowY: "none" }}>
        <ul className="nav nav-tabs navbar-expand small">
          <li className="nav-item " role="button">
            <span
              className="nav-link color-strong-grey nav-ellipsis  active"
              data-bs-toggle="tab"
              data-bs-target={"#google-geocoding"}
            >
              <span className="color-black">Geocoding</span>
            </span>
          </li>
          <li className="nav-item " role="button">
            <span
              className="nav-link color-strong-grey nav-ellipsis "
              data-bs-toggle="tab"
              data-bs-target={"#google-reverse-geocoding"}
            >
              <span className="color-black">Reverse Geocoding</span>
            </span>
          </li>
        </ul>
      </PerfectScrollbar>
      <div className="tab-content mt-3 ">
        <div
          className="tab-pane fade active show"
          id="google-geocoding"
          role="tabpanel"
          aria-labelledby="google-geocoding"
        >
          <div className="mt-2 text-end">
            <button
              className="btn btn-sm btn-white border rounded "
              onClick={() => {
                window["map"].on("singleclick", onGoogleReverseGeocoding);
              }}
            >
              <i className="fas fa-map-pin me-2"></i>
              {trans("Click on the map")}
            </button>
          </div>
        </div>
        <div
          className="tab-pane fade"
          id="google-reverse-geocoding"
          role="tabpanel"
          aria-labelledby="google-reverse-geocoding"
        >
          <div className="mt-2">
            <input
              type="text"
              className="form-control form-control-sm"
              placeholder={trans("Type an address")}
              onChange={(e) => {
                reverseGeocoding(e.target.value);
              }}
            ></input>
            {reverseGeocodingResults.length > 0 ? (
              <div className="google-reverse-geocoding-results bg-white mt-1 border rounded">
                <PerfectScrollbar style={{ maxHeight: "12rem" }}>
                  <ul>
                    {reverseGeocodingResults.map((el) => {
                      return (
                        <li
                          className="pointer text-secondary"
                          onClick={() => {
                            const address = el.formatted_address;

                            const { lat, lng } = el.geometry.location;

                            let point = {
                              projection: "EPSG:4326",
                              event: { coordinate: [lng, lat], pixel: [] },
                              label: address,
                            };

                            store.dispatch({
                              type: "map/google/geocoding/add",
                              payload: { ...point },
                            });
                          }}
                        >
                          <span className="small " onClick={() => {}}>
                            {el.formatted_address}
                          </span>
                        </li>
                      );
                    })}
                  </ul>
                </PerfectScrollbar>
                <div
                  className=" small border-top ps-2 d-block d-flex"
                  style={{ backgroundColor: "#eaeaea" }}
                >
                  <span className="w-50">
                    {trans("Total").concat(
                      ": ",
                      reverseGeocodingResults.length
                    )}
                  </span>
                  <span
                    className="pointer pe-2 w-50 text-end"
                    onClick={() => {
                      setReverseGeocodingResults([]);
                    }}
                  >
                    <i className="fas fa-times me-1 small"></i>
                    {trans("Close")}
                  </span>
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
      <PerfectScrollbar className="scrollbar-recaclulate">
        <div className="me-3">
          {googleGeocoding.map((el, index) => {
            let idx = googleGeocoding.length - index;

            return (
              <div className="card mt-3 ">
                <div className="  me-2 mt-1 d-flex ps-3 pt-2" role="button">
                  <span className="color-get-blue w-100">
                    {el.label ? el.label : trans("Point").concat(" ", idx + 1)}
                  </span>
                  <i
                    className="fas fa-trash-alt color-black fa-sm"
                    onClick={() => {
                      store.dispatch({
                        type: "map/google/geocoding/delete",
                        payload: index,
                      });
                    }}
                  ></i>
                </div>
                <div className="card-body">
                  <div className="mb-3">
                    <label className="color-get-blue strong small">
                      {trans("Projection system")}: {el.projection}
                    </label>
                  </div>
                  <div className="mb-3">
                    <label className="color-get-blue strong small ">
                      {trans("Coordinates")}: {el.event.coordinate.join(" , ")}
                    </label>
                  </div>

                  <div className=" text-end">
                    <button
                      className="btn btn-white btn-sm border me-2"
                      onClick={() => {
                        getFeatureInfo(el.event, layers, sources, store);
                      }}
                    >
                      <span className="small">{trans("Get feature info")}</span>
                    </button>
                    <button className="btn btn-success btn-sm">
                      <span
                        className="text-white small"
                        onClick={() => {
                          console.log(el);
                          showPoint(el.event.coordinate, el.projection);
                        }}
                      >
                        {trans("Show point")}
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </PerfectScrollbar>
    </div>
  );
}

export default GooglePanel;
